export const empathyIcons = [
  { icon: "ri-shield-check-line", label: "Discreet support" },
  { icon: "ri-heart-pulse-line", label: "Gentle accountability" },
  { icon: "ri-compass-3-line", label: "Calm guidance" },
  { icon: "ri-footprint-line", label: "Practical next steps" },
];

export const howSupportWorks = [
  {
    step: "1",
    title: "Start with a conversation",
    description:
      "We begin with a calm, confidential conversation about where you are now, what feels hard, and what kind of support would help most.",
  },
  {
    step: "2",
    title: "Create small, realistic steps",
    description:
      "Together, we focus on manageable changes — whether that means reducing drinking, handling cravings, or rebuilding your evenings in a more supportive way.",
  },
  {
    step: "3",
    title: "Receive ongoing encouragement",
    description:
      "You'll have a steady space for reflection, accountability, and support as you build new habits and patterns.",
  },
  {
    step: "4",
    title: "Build a life that feels steadier",
    description:
      "The aim is not perfection. It's helping you feel clearer, stronger, more in control, and more connected to the life you want.",
  },
];

export const areasOfSupport = [
  {
    title: "Cravings and difficult moments",
    description:
      "Gentle support when urges feel strong, including tools to pause, reset, and respond differently.",
  },
  {
    title: "Emotional triggers",
    description:
      "Understanding the feelings, situations, and patterns that pull you back into old habits.",
  },
  {
    title: "Rebuilding routines",
    description:
      "Creating steadier daily and evening routines that feel comforting, realistic, and sustainable.",
  },
  {
    title: "Accountability and check-ins",
    description:
      "Regular support to help you stay connected to your progress and keep moving forward.",
  },
  {
    title: "Self-trust and confidence",
    description:
      "Rebuilding confidence in yourself, your choices, and your ability to handle life without leaning on alcohol.",
  },
  {
    title: "A calmer future",
    description:
      "Support in creating a life that feels more peaceful, present, and genuinely yours.",
  },
];

export const eveningRoutineBullets = [
  "Replace autopilot habits with mindful routines",
  "Create healthier ways to unwind",
  "Build rituals that feel nurturing and realistic",
  "Stay connected during difficult moments",
];

export const values = [
  "Compassion over criticism",
  "Progress over perfection",
  "Privacy over pressure",
  "Practical support over overwhelm",
];

export const resources = [
  {
    title: "Reflection prompts",
    description:
      "Simple prompts to help you notice patterns, triggers, and progress with honesty and self-compassion.",
  },
  {
    title: "Routine support",
    description:
      "Gentle guidance for rebuilding evenings, mornings, and daily rhythms that feel steadier and more supportive.",
  },
  {
    title: "Practical recovery tools",
    description:
      "Helpful ideas for navigating cravings, reducing overwhelm, and staying connected to your next step.",
  },
];

export const testimonials = [
  {
    quote:
      "I felt understood without being judged. The support felt calm, practical, and genuinely encouraging.",
    name: "A private client",
  },
  {
    quote:
      "For the first time, I felt like I had permission to take small steps instead of trying to change everything at once.",
    name: "A private client",
  },
  {
    quote:
      "Quiet Recovery Space helped me create new routines that actually felt realistic and supportive.",
    name: "A private client",
  },
];